import React from 'react';

const Step4Infos = (props) => {
    return (
        <div className="slc-wizard-infos-step slc-wizard-infos-step-4">
        Se devi installare un solo condizionatore, in una unica stanza, dovrai acquistare un Monosplit.<br />
        Se devi installare più condizionatori su stanze che sono attigue, potrai scegliere anche impianti Multisplit.<br /><br />
        Per ottenere la massima resa nel caso di installazione di multisplit è necessario la non contemporaneità di utilizzo.
        </div>
    );
}

export default Step4Infos;